import React, { useState } from 'react';
import { useNavigate } from 'react-router';

const DISMISS_KEY = 'optiprime-system-alerts-dismissed';

export function isSystemAlertsDismissed() {
  try {
    return sessionStorage.getItem(DISMISS_KEY) === '1';
  } catch {
    return false;
  }
}

export function dismissSystemAlerts() {
  try {
    sessionStorage.setItem(DISMISS_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function clearSystemAlertsDismiss() {
  try {
    sessionStorage.removeItem(DISMISS_KEY);
  } catch {
    /* ignore */
  }
}

export default function SystemAlertsModal({ alerts, onClose }) {
  const navigate = useNavigate();
  const [expandedId, setExpandedId] = useState(null);

  if (!alerts || alerts.length === 0) return null;

  const handleDismiss = () => {
    dismissSystemAlerts();
    onClose();
  };

  const handleSendReminder = (email) => {
    navigate(`/communications?compose=1&to=${encodeURIComponent(email)}&template=tpl_login_01`);
    onClose();
  };

  return (
    <div className="modal-overlay system-alerts-overlay" onClick={handleDismiss}>
      <div className="modal-content system-alerts-modal opo-tactical" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>
            <span className="opo-pip opo-pip-warning" aria-hidden="true">
              <span className="opo-pip-core" />
            </span>
            {' '}
            System Alerts
          </h2>
          <button type="button" className="close-button" onClick={handleDismiss} aria-label="Dismiss">
            ×
          </button>
        </div>
        <div className="modal-body system-alerts-body">
          <p className="system-alerts-intro">
            The following items need your attention. Alerts clear automatically when resolved.
          </p>
          {alerts.map((alert) => {
            const isExpanded = expandedId === alert.id;
            return (
              <div key={alert.id} className={`system-alert-card system-alert-${alert.severity || 'warning'}`}>
                <div className="system-alert-head">
                  <span className={`opo-pip opo-pip-${alert.severity === 'critical' ? 'critical' : 'warning'}`}>
                    <span className="opo-pip-core" />
                  </span>
                  <div className="system-alert-summary">
                    <strong>{alert.title}</strong>
                    <span>{alert.summary}</span>
                  </div>
                  <button
                    type="button"
                    className="system-alert-detail-btn"
                    onClick={() => setExpandedId(isExpanded ? null : alert.id)}
                  >
                    {isExpanded ? 'Hide details' : 'View details'}
                  </button>
                </div>
                {isExpanded && Array.isArray(alert.items) && alert.items.length > 0 && (
                  <div className="system-alert-items">
                    <table className="system-alert-table">
                      <thead>
                        <tr>
                          <th>User</th>
                          <th>Email</th>
                          <th>Credentials sent</th>
                          <th>Days waiting</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {alert.items.map((item) => (
                          <tr key={item.userId || item.email}>
                            <td>
                              {item.name}
                              <br />
                              <small>@{item.username}</small>
                            </td>
                            <td>{item.email}</td>
                            <td>
                              {item.welcomeEmailSentAt
                                ? new Date(item.welcomeEmailSentAt).toLocaleString()
                                : '—'}
                            </td>
                            <td>{item.daysSinceEmail != null ? item.daysSinceEmail : '—'}</td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-secondary system-alert-remind-btn"
                                onClick={() => handleSendReminder(item.email)}
                              >
                                Send reminder
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <div className="system-alerts-footer">
          <button type="button" className="btn btn-primary" onClick={handleDismiss}>
            Dismiss for this session
          </button>
        </div>
      </div>
    </div>
  );
}
